import { useLayoutEffect, useState } from 'react';
import { Producto } from './Producto';
import { Box, Text } from '@bpba/ui-components';
import { Filtros } from '../filtros/Filtros';
import { ModuleContainerGeneric } from '@bpba/modules-components';
import { ProductoData } from '../../model/ProductoData';
import { Titulo } from '../shared/Titulo';
import { StyledButton } from '../shared/StyledButton';
import { useDevice } from '@bpba/ui-components';
import { useUserStatus } from '../../config/authentication/useUserStatus';
import { SinProductos } from './SinProductos';
import { StyledModuleContainerGeneric } from '../shared/StyledModuleContainerGeneric';

type CatalogoComponentProps = {
  orden: number;
  data: ProductoData[];
  moduloTitulo?: string;
  hideFilters?: boolean;
  hidePage?: boolean;
  prodPorFilaList?: number[];
  iconoRubro?: string;
  showRubroFilter?: boolean;
  rubroId?: string | undefined;
  legales?: string | undefined;
  isOnTop?: boolean;
};

export const CatalogoComponent = (props: CatalogoComponentProps) => {
  const productosPorFilaList = props.prodPorFilaList ? props.prodPorFilaList : [1, 3, 5]; //Cuántos productos por fila se muestran, para cada resolución
  const perPageList = [4, 4, 9, 8, 10]; //Cuántos productos se muestran en cada página, para cada resolución

  let [productosPorFila, setProductosPorFila] = useState(productosPorFilaList[productosPorFilaList.length - 1]);
  let [perPage, setPerPage] = useState(perPageList[perPageList.length - 1]);
  let [page, setPage] = useState(1);
  let [puntosDesde, setPuntosDesde] = useState(0);
  let [puntosHasta, setPuntosHasta] = useState(Number.MAX_VALUE);
  let [ordenPor, setOrdenPor] = useState('');
  const { isLoggedin } = useUserStatus();
  const device = useDevice();

  const selectConfig = () => {
    for (let i = 0; i < productosPorFilaList.length; i++) {
      if (device === 'mobile') {
        setPerPage(perPageList[i]);
        setProductosPorFila(productosPorFilaList[i]);
        break;
      }
    }
    if (device === 'tablet') {
      setPerPage(perPageList[perPageList.length - 2]);
      setProductosPorFila(productosPorFilaList[productosPorFilaList.length - 2]);
    }
    if (device === 'desktop') {
      setPerPage(perPageList[perPageList.length - 1]);
      setProductosPorFila(productosPorFilaList[productosPorFilaList.length - 1]);
    }
  };

  useLayoutEffect(() => {
    const handleResize = () => {
      selectConfig();
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  let list = props.data?.filter((producto) => producto.puntos >= puntosDesde && producto.puntos < puntosHasta);
  let totalPage = list.length / perPage;
  if (ordenPor === 'desc') {
    list?.sort((a, b) => b.puntos - a.puntos);
  }
  if (ordenPor === 'asc') {
    list?.sort((a, b) => a.puntos - b.puntos);
  }

  const listProductos = (data: ProductoData[], page: number, perPage: number) => {
    return data.slice(0, page * perPage);
  };

  let items = listProductos(list, page, perPage).map((producto, index) => {
    return (
      <Producto
        key={producto.codigo}
        id={'producto_' + index}
        data={producto}
        width={['calc(calc(100% - ' + (productosPorFila - 1).toString() + ' * 16px)/' + productosPorFila.toString() + ')']}
        isLast={(index + 1) % productosPorFila === 0}
      />
    );
  });

  const focusElement = (id: string) => {
    setTimeout(() => {
      document.getElementById(id)?.focus();
    }, 500);
  };

  return (
    <>
      <StyledModuleContainerGeneric
        paddingBottom={['32px !important']}
        paddingTop={props.isOnTop && !isLoggedin ? ['0px !important'] : ['40px !important']}
      >
        <Titulo icono={props.iconoRubro}>{props.moduloTitulo}</Titulo>
      </StyledModuleContainerGeneric>
      <ModuleContainerGeneric marginBottom={0} paddingBottom={['64px']} paddingTop={'0px !important'}>
        {!props.hideFilters && (
          <Box>
            <Filtros
              setPuntosDesde={setPuntosDesde}
              setPuntosHasta={setPuntosHasta}
              setOrdenPor={setOrdenPor}
              showFiltroRubro={props.showRubroFilter}
            />
          </Box>
        )}

        {items.length > 0 ? (
          <Box display={'flex'} flexWrap={'wrap'} flexDirection={'row'}>
            {items}
          </Box>
        ) : (
          <SinProductos />
        )}

        {items.length > 0 && !props.hidePage && (
          <Text textAlign={'right'} tabIndex={0} py={'16px'}>
            Mostrando {items.length} de {list.length}
          </Text>
        )}

        {items.length > 0 && page < totalPage && (
          <Box justifyContent={'center'}>
            <StyledButton
              variant={'secondary'}
              width="fit-content !important"
              onClick={() => {
                const id = page * perPage;
                setPage(page + 1);
                focusElement('producto_' + id);
              }}
            >
              Ver más
            </StyledButton>
          </Box>
        )}
        {props.legales && props.legales.trim()?.length > 0 && (
          <Box paddingBottom={'40'} paddingTop={'40px'} display={items.length > 0 && props.rubroId ? 'flex' : 'none'}>
            <Text color={'primary.0'} fontWeight={500}>
              <a href={props.legales.trim()}>CONOCÉ LOS TÉRMINOS Y CONDICIONES DE ESTA ACCIÓN ESPECIAL</a>
            </Text>
          </Box>
        )}
      </ModuleContainerGeneric>
    </>
  );
};
